export default[
    {
        path: '/biomedica',
        component: () => import(/* webpackChunkName: "biomedica" */ '@/views/Biomedica.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_PACIENTES'],
        },
        children:[
            {
                path:'/',
                name:'biomedicaNuevaSolicitud',
                component: () => import(/* webpackChunkName: "biomedicaNuevaSolicitud" */ '@/views/biomedica/NuevaSolicitud.vue'),
                requiresAuth: true,
                roles:['ROLE_PACIENTES'],
            },
            {
                path:'solicitud/:id',
                name:'biomedicaDetalle',
                component: () => import(/* webpackChunkName: "biomedicaDetalle" */ '@/views/biomedica/DetalleSolicitud.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'listado',
                name:'biomedicaListado',
                component: () => import(/* webpackChunkName: "biomedicaListado" */ '@/views/biomedica/Solicitudes.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'equipos',
                name:'biomedicaCatalogoEquipos',
                component: () => import(/* webpackChunkName: "biomedicaCatalogoEquipos" */ '@/views/biomedica/CatalogoEquipos.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'equipo/:id',
                name:'biomedicaEquipoSolo',
                component: () => import(/* webpackChunkName: "biomedicaEquipoSolo" */ '@/views/biomedica/EquipoDetalle.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'nuevoequipo',
                name:'biomedicaNuevoEquipo',
                component: () => import(/* webpackChunkName: "biomedicaNuevoEquipo" */ '@/views/biomedica/NuevoEquipo.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'manuales',
                name:'biomedicaManuales',
                component: () => import(/* webpackChunkName: "biomedicaManuales" */ '@/views/biomedica/BiomedicaManuales.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
        ]
    }
]